export default __webpack_public_path__ + "media/images/tenant/howToRentApartment/step_2-f5593adacf758820332e5e4a1c8955ee.webp";